'use client';

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../contexts/ApiContext';
import type { RushMidConfigResponse } from '../services/generated/Api';

export type RushMidConfig = RushMidConfigResponse;

export function useRushMidConfig(): RushMidConfig {
  const apiClient = useApiClient();
  const { data } = useQuery({
    queryKey: ['rush-mid-config'],
    queryFn: () => apiClient.api.rushMidControllerGetConfig(),
    staleTime: 0,
    refetchOnMount: 'always',
    refetchInterval: 60_000,
  });
  return { comingSoon: data?.comingSoon ?? false, maintenance: data?.maintenance ?? false, activeTickets: data?.activeTickets ?? [] };
}
